import { StockStatus } from '../stock-status';

export function useStockStatus(stockStatus: string | null | undefined) {
    return stockStatus ? (stockStatus as StockStatus) : StockStatus.Status4;
}
